import { render, staticRenderFns } from "./PersonalRobberyEventTypeQuestion.vue?vue&type=template&id=d1fb15aa&scoped=true"
import script from "./PersonalRobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
export * from "./PersonalRobberyEventTypeQuestion.vue?vue&type=script&lang=ts"
import style0 from "./PersonalRobberyEventTypeQuestion.vue?vue&type=style&index=0&id=d1fb15aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1fb15aa",
  null
  
)

export default component.exports